export * from './activety.component'